var map = {
	"./bazar.png": 949,
	"./footerLogo.jpg": 3446,
	"./googlePlay.svg": 5699,
	"./logo.png": 5080,
	"./mayket.svg": 4828,
	"./web home 2022.jpg": 3645
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5459;